import { useState, useEffect } from "react";
import { Layout, Menu, Button, Drawer } from "antd";
import {
  HomeOutlined,
  FileOutlined,
  FileTextOutlined,
  FormOutlined,
  BarChartOutlined,
  PictureOutlined,
  PoweroffOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import logo_dark from "../img/logo_white.png";
import AppFooter from "../components/Footer";
import "./MainLayout.css";
import { useAuth } from "../components/AuthContext";
import authService from "../services/auth.service";
import anketaService from "../services/anketa.service";
import clanakService from "../services/clanak.service";

const { Header, Content } = Layout;

function MainLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const [sectionTitle, setSectionTitle] = useState("");
  const { logout } = useAuth();

  const [drawerVisible, setDrawerVisible] = useState(false);

  const handleMenuClick = ({ key }) => {
    navigate(key);
    setDrawerVisible(false);
  };

  useEffect(() => {
    const path = location.pathname;

    const anketaMatch = path.match(/\/anketa\/(\d+)/);
    const clanakMatch = path.match(/\/clanci\/(\d+)/);

    if (anketaMatch) {
      const anketaId = anketaMatch[1];
      anketaService
        .getById(anketaId)
        .then((response) => {
          setSectionTitle(response.data.naziv);
        })
        .catch((err) => {
          setSectionTitle("Anketa");
        });
      return;
    }
    if (clanakMatch) {
      const clanakId = clanakMatch[1];
      clanakService
        .getById(clanakId)
        .then((response) => {
          setSectionTitle(response.data.naslov);
        })
        .catch((err) => {
          setSectionTitle("Clanak");
        });
      return;
    }

    const routeTitles = {
      "/zaposleni/home": "Početna stranica",
      "/zaposleni/kategorijaDokumenta/1": "Želimo da podijelimo sa vama",
      "/zaposleni/kategorijaDokumenta/2": "Naši materijali",
      "/zaposleni/kategorijaDokumenta/3": "Izvještaji",
      "/zaposleni/kategorijaClanka/1": "Ko smo mi?",
      "/zaposleni/kategorijaClanka/2": "Kako je sve počelo?",
      "/zaposleni/kategorijaClanka/3": "Šta interesuje naše studente?",
      "/zaposleni/kategorijaClanka/4": "Naša postignuća",
      "/zaposleni/ankete/sve": "Ankete",
      "/zaposleni/dodaj-anketu": "Kreiranje nove ankete",
      "/zaposleni/dodaj-clanak": "Kreiranje novog članka",
      "/zaposleni/galerija": "Galerija",
      "/zaposleni/statistika/clanka": "Statistika članaka",
      "/zaposleni/statistika/dokumenata": "Statistika dokumenata",
    };

    setSectionTitle(routeTitles[path] || "");
  }, [location.pathname]);

  const handleLogOut = async () => {
    try {
      await authService.logout();
      logout();
      navigate("/home");
    } catch (err) {
    }
  };

   const selectedKey = location.pathname === "/" ? "/home" : location.pathname;

  const renderMenu = () => (
    <Menu
      selectedKeys={[selectedKey]}
      mode="inline"
      onClick={handleMenuClick}
    >
      <Menu.Item key="/zaposleni/home" icon={<HomeOutlined />}>
        Početna stranica
      </Menu.Item>

      <Menu.SubMenu key="/dokumenti" icon={<FileOutlined />} title="Dokumenti">
        <Menu.Item key="/zaposleni/kategorijaDokumenta/1">
          Želimo da podijelimo sa vama
        </Menu.Item>
        <Menu.Item key="/zaposleni/kategorijaDokumenta/2">
          Naši materijali
        </Menu.Item>
        <Menu.Item key="/zaposleni/kategorijaDokumenta/3">Izvještaji</Menu.Item>
      </Menu.SubMenu>

      <Menu.SubMenu key="/clanci" icon={<FileTextOutlined />} title="Članci">
        <Menu.Item key="/zaposleni/kategorijaClanka/1">Ko smo mi?</Menu.Item>
        <Menu.Item key="/zaposleni/kategorijaClanka/2">
          Kako je sve počelo?
        </Menu.Item>
        <Menu.Item key="/zaposleni/kategorijaClanka/3">
          Šta interesuje naše studente?
        </Menu.Item>
        <Menu.Item key="/zaposleni/kategorijaClanka/4">
          Naša postignuća
        </Menu.Item>
      </Menu.SubMenu>

      <Menu.Item key="/zaposleni/ankete/sve" icon={<FormOutlined />}>
        Ankete
      </Menu.Item>

      <Menu.Item key="/zaposleni/galerija" icon={<PictureOutlined />}>
        Galerija
      </Menu.Item>

      <Menu.SubMenu
        key="statistika"
        icon={<BarChartOutlined />}
        title="Statistika"
      >
        <Menu.Item key="/zaposleni/statistika/clanka">
          Statistika članaka
        </Menu.Item>
        <Menu.Item key="/zaposleni/statistika/dokumenata">
          Statistika dokumenata
        </Menu.Item>
      </Menu.SubMenu>
    </Menu>
  );

  return (
    <Layout style={{ minHeight: "100vh", backgroundColor: "transparent" }}>
      <Header className="custom-header">
        <div className="header-left">
          <Button
            className="menu-toggle"
            icon={<MenuOutlined />}
            onClick={() => setDrawerVisible(true)}
          />
          <Link to="/zaposleni/home">
            <img
              src={logo_dark}
              alt="Logo"
              className="header-logo clickable-logo"
            />
          </Link>
        </div>

        <div className="header-right">
          <Button
            className="user_button"
            icon={<PoweroffOutlined />}
            onClick={handleLogOut}
          />
        </div>
      </Header>
      <div className="docs-div2">
        <p className="docs-p">{sectionTitle}</p>
      </div>

      <Drawer
        title="Navigacija"
        placement="left"
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        className="drawer-layout-style"
      >
        {renderMenu()}
      </Drawer>

      <Layout className="site-layout">
        <Content style={{ minHeight: "280px" }}>
          <Outlet />
        </Content>
        <AppFooter />
      </Layout>
    </Layout>
  );
}

export default MainLayout;
